$.fn.ChatBot = function() {
  let self = this

  self.conversation_id = ''
  self.latest_user_message = '_'
  self.latest_bot_message = '_'

  self.message_sent = function() {
    let input = self.find('.chatbot__prompt'),
    message = input.val().trim()
    self.addClass('--on-going')
    if (!message) return
    $.ajax({
      url: '/chat/v1/message',
      method: 'POST',
      dataType: 'json',
      data: {
        message: message,
        conversation_id: self.conversation_id
      }
    }).done(function(response) {
      if (response.success) {
        if (response.conversation) {
          self.conversation_id = response.conversation
        }
        if (response.message) {
          self.latest_user_message = response.message
        }
        self.find('.message--from-user').last().attr('data-message-id', response.message)
        clearInterval(self.poll_conversation);
        self.poll_conversation = setInterval(function() {
          $.ajax({
            url: '/chat/v1/conversation/' + self.conversation_id + '/' + encodeURIComponent(self.latest_user_message) + '/' + encodeURIComponent(self.latest_bot_message) + '/',
            method: 'GET',
            dataType: 'json'
          }).done(function(response) {
            if (response.updated) {
              self.latest_bot_message = response.latest_bot_message || self.latest_bot_message
              self.latest_user_message = response.latest_user_message || self.latest_user_message
              if (response.html != false) {
                if (response.latest == 'user') {
                  self.addClass('--thinking')
                } else {
                  self.removeClass('--thinking')
                }
                self.find('.chatbot__messages').html(response.html)
                $('.report-progress').each(function () {
                  $(this).ReportProgress()
                })
              }
            }
          })
        }, 2000)
      }
    })
    var formated_message = message.split('\n\n')
    .filter(line => line.trim())
    .map(line => '<p>' + line + '</p>')
    .join('');
    formated_message = formated_message.replace(/\n/g, '<br>');
    self.find('.chatbot__messages').append('<div class="message message--from-user">' + formated_message + '</div>')
    self.addClass('--thinking')
    input.val('').focus()
    self.alignScroll();
  }

  self.alignScroll = function() {
    $('html').animate({
      scrollTop: $('html')[0].scrollHeight
    }, 300);
  }

  self.adjustInputHeight = function() {
    var input = $('.chatbot__prompt')[0];
    input.style.height = 'auto';

    const lineHeight = parseFloat(getComputedStyle(input).lineHeight);
    const paddingTop = parseFloat(getComputedStyle(input).paddingTop);
    const paddingBottom = parseFloat(getComputedStyle(input).paddingBottom);
    const maxHeight = (lineHeight * 8) + paddingTop + paddingBottom;
    input.style.overflowY = 'hidden';
    input.style.height = input.scrollHeight + 'px';

    if (input.scrollHeight > maxHeight) {
      input.style.height = maxHeight + 'px';
      input.style.overflowY = 'auto';
    }
  }

  self.initialize = function() {
    self.find('.chatbot__suggestion').on('click', function () {
      const textToAdd = $(this).text();
      const $textarea = self.find('.chatbot__prompt');
      const current = $textarea.val();
      $textarea.val(current + textToAdd + ' ');
      $textarea.focus()[0].setSelectionRange($textarea.val().length, $textarea.val().length);
    });

    self.find('.chatbot__submit').on('click', function(e) {
      e.preventDefault()
      self.message_sent()
    })

    self.find('.chatbot__prompt').on('keypress', function(e) {
      if (e.which === 13 && !e.shiftKey) {
        e.preventDefault()
        self.message_sent()
        self.adjustInputHeight();
      }
    })

    self.find('.chatbot__prompt').on('input', function () {
      self.adjustInputHeight();
    });
  }

  return function() {
    self.initialize()

    $(window).on('load resize orientationchange', function() {
      self.adjustInputHeight();
    })
    return self
  }()
}

$.fn.ReportProgress = function() {
  let self = this
  self.initialized = false;

  self.initialize = function() {
    if (self.initialized === false) {
      self.wrapInner('<div class="report-progress__title"></div>');
      self.wrapInner('<div class="report-progress__title-wrapper"></div>');
      self.find('.report-progress__title-wrapper').append('<span class="report-progress__percentage">0%</span>')
      self.append('<div class="report-progress__track"><div class="report-progress__bar"></div></div>')
      self.updateProgress();
      self._interval = setInterval(self.updateProgress, 1000);
      self.initialized = true;
    }
  }

  self.updateProgress = function() {
    var totalMinutes = parseInt(self.data('time'), 10);
    var createdAt = new Date(self.data('creared')); // typo preserved as in your HTML
    var now = new Date();

    var elapsedMs = now - createdAt;
    var totalMs = totalMinutes * 60 * 1000;
    var remainingMs = totalMs - elapsedMs;
    var remainingMinutes = Math.max(0, Math.ceil(remainingMs / 60000));

    var percent = Math.min(100, Math.max(0, (elapsedMs / totalMs) * 100));
    if (percent > 95) {
      percent = 95;
    }
    var percentText = Math.round(percent) + '%';

    var $start = self.closest('.message'); // self = .report-progress
    var $nextProgress = $start.nextAll('.message:has(.report-progress)').first();
    var $inBetween;

    if ($nextProgress.length) {
      $inBetween = $start.nextUntil($nextProgress, '.message');
    } else {
      $inBetween = $start.nextAll('.message');
    }

    var hasDownload = $inBetween.find('.btn-download').length > 0;

    if (hasDownload) {
      self.find('.report-progress__title').html('Completed: ' + $inBetween.find('.btn-download').clone().wrap('<div>').parent().html());
      self.find('.report-progress__percentage').text('100%');
      self.find('.report-progress__bar').css('width', '100%');

      if (self._interval) {
        clearInterval(self._interval);
        self._interval = null;
      }
    } else {
      if (remainingMinutes < 1) {
        self.find('.report-progress__title').text('Almost ready...');
      } else {
        self.find('.report-progress__title').text('Estimated time: ' + remainingMinutes + ' minute' + (remainingMinutes === 1 ? '' : 's') + '.');
      }
      self.find('.report-progress__percentage').text(percentText);
      self.find('.report-progress__bar').css('width', percentText);
    }
  }

  return function() {
    self.initialize()
    return self
  }()
}



export default {
  init() {
    $('.chatbot').each(function() {
      $(this).ChatBot()
      $('.report-progress').each(function () {
        $(this).ReportProgress()
      })
    })
  },
}
